import{ClientResponse}from'./ClientResponse';export class JsonClientResponse extends ClientResponse{constructor(value,statusCode){super(value,statusCode);}}